/**
 * hot-sap-adaptive-header.js
 *
 * Watches which section is currently behind the sticky header and sets
 * `data-over-dark` on the `header-component` element when the header
 * is over a section that carries `data-header-theme="dark"`.
 *
 * CSS in hot-sap-foundations.css reads that attribute to switch between
 * the cream-translucent light-mode header (over white/cream sections)
 * and the default maroon scheme (over dark maroon sections).
 *
 * Only runs on product pages — the script tag is injected by
 * hot-sap-product-announce.liquid which is product-page-only.
 */
(function () {
  'use strict';

  var header = null;
  var rafId = null;

  function getHeader() {
    if (!header) header = document.querySelector('header-component');
    return header;
  }

  function updateHeaderTheme() {
    var h = getHeader();
    if (!h) return;

    var headerBottom = h.getBoundingClientRect().bottom;
    var sections = document.querySelectorAll('[data-header-theme]');
    var overDark = false;

    for (var i = 0; i < sections.length; i++) {
      var rect = sections[i].getBoundingClientRect();
      // A section is "behind the header" when its top is above the header's
      // bottom edge AND its bottom is still visible (above the fold).
      if (rect.top < headerBottom && rect.bottom > 0) {
        if (sections[i].dataset.headerTheme === 'dark') {
          overDark = true;
          break;
        }
      }
    }

    if (overDark) {
      h.setAttribute('data-over-dark', '');
    } else {
      h.removeAttribute('data-over-dark');
    }
  }

  function onScroll() {
    if (rafId) return;
    rafId = requestAnimationFrame(function () {
      rafId = null;
      updateHeaderTheme();
    });
  }

  window.addEventListener('scroll', onScroll, { passive: true });

  // Run once on load so the initial state is correct.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateHeaderTheme);
  } else {
    updateHeaderTheme();
  }
})();
